import * as S from './styled';

import type {
  IconProps,
} from './styled';

/**
 * Icon
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
const Icon = ({
  type,
  size = 'inherit',
  color = 'inherit',
  transform,
}: IconProps) => (
  <S.StyledIcoin
    size={size}
    color={color}
    transform={transform}
    className={`${type}`}
  />
);

export default Icon;
